import { useKeycloak } from '@react-keycloak/web';
import { useCallback } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { getConfig } from '../../config/config';
import { useIsTenantAdmin } from '../../hooks/useIsTenantAdmin';

type Location = Record<string, unknown>;

const LoginPage = () => {
  const { keycloak } = useKeycloak();
  const location = useLocation<Location>();
  const isTenantAdmin = useIsTenantAdmin();

  const getCurrentLocationState = (): Location => {
    let pathname = '';

    if (!isTenantAdmin) {
      pathname = '/info';
    }

    if (
      isTenantAdmin &&
      getConfig().showApikeyManagement?.toString()?.toLowerCase() === 'true'
    ) {
      pathname = '/apikeys';
    }

    if (
      isTenantAdmin &&
      getConfig().showUserManagement?.toString()?.toLowerCase() === 'true'
    ) {
      pathname = '/users';
    }

    return (
      location.state || {
        from: { pathname },
      }
    );
  };

  const login = useCallback(() => {
    keycloak?.login();
  }, [keycloak]);

  if (keycloak?.authenticated)
    return <Redirect to={getCurrentLocationState()?.from as string} />;

  return <>{login()}</>;
};

export default LoginPage;
